<template>
    <header>
        <div class="mobile">
            <button @click="$emit('sidenav')" class="sidenav-button"><span class="ion ion-md-menu"/></button>
            <router-link to="/" class="logoLink"><img class="logo" src="../../common/assets/logo-color-round.svg"><span>{{
                    $t('common.appname')
                }}</span>
            </router-link>
        </div>
        <div class="inpageHeaderPlaceholder" ref="inpageHeaderPlaceholder">

        </div>
        <div class="userInfo-wrapper">
            <div class="userInfo">
                <div class="dropButton" @click="openDropMenu"><span>{{ name }}</span>
                    <div class="avatar ion ion-ios-person"/>
                </div>
                <div class="dropMenu">
                    <router-link to="/user/myProfile" ref="myProfileLink">{{ $t('common.my profile') }}</router-link>
                    <button @click="logout">{{ $t('common.log out') }}</button>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
export default {
    mounted() {
        this.resizeObserver = new ResizeObserver(() => {
            this.refreshSizes();
            this.$nextTick(() => this.refreshSizes());
        });
        this.resizeObserver.observe(this.$refs.inpageHeaderPlaceholder);
        this.refreshSizes();
        this.$nextTick(() => this.refreshSizes());
        setInterval(this.refreshSizes.bind(this), 1000);
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
            if (this.$route.path != '/')
                this.$router.push('/');
        },
        async openDropMenu(e) {
            e.preventDefault();
            e.stopPropagation();
            await this.$nextTick();
            this.$refs.myProfileLink.$el.focus()
        },
        refreshSizes() {
            if (this.$refs.inpageHeaderPlaceholder) {
                const box = this.$refs.inpageHeaderPlaceholder.getBoundingClientRect();
                document.body.style.setProperty('--inpage-header-placeholder-height', box.height + 'px');
                document.body.style.setProperty('--inpage-header-placeholder-width', box.width + 'px');
                document.body.style.setProperty('--inpage-header-placeholder-left', box.left + 'px');
                document.body.style.setProperty('--inpage-header-placeholder-top', (box.top + scrollY) + 'px');
            }
        }
    },
    computed: {
        name() {
            return this.$store.state.commonData.data?.user?.firstName + ' ' + this.$store.state.commonData.data?.user?.lastName
        }
    }
}
</script>
